module.exports = __webpack_public_path__ + "static/media/prizes.62a7d2ca.png";